export const moneda = (value) =>
  `$ ${Number(value || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const cantidad = (value, unidad = '') => {
  const n = Number(value || 0);
  const str = n.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
  return unidad ? `${str} ${unidad}` : str;
};

export const fechaCorta = (isoStr) => {
  if (!isoStr) return '—';
  return new Date(isoStr).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/** Genera array de los últimos N días con datos del resumen */
export const completarDias = (ventasDias, n = 7) => {
  const map = {};
  ventasDias.forEach((d) => { map[d.dia] = parseFloat(d.total); });

  return Array.from({ length: n }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (n - 1 - i));
    const key   = d.toISOString().split('T')[0];
    const label = d.toLocaleDateString('es-AR', { weekday: 'short', day: 'numeric' });
    return { dia: label, total: map[key] ?? 0 };
  });
};
